export default {
  title: 'Pagar con {{method}}',
  hint: 'Toca el botón de abajo y aprueba el pago en la ventana de {{method}}.',
  confirming: 'Confirmando tu pago…',
  cancel: 'Cancelar pago',
  unavailable: 'Este método de pago no está disponible en este momento. Elige otro.',
  approval_timeout:
    'No recibimos respuesta de {{method}}. Si su ventana no se abrió, comprueba que las ventanas emergentes estén permitidas, luego inténtalo de nuevo o elige otro método de pago.',
};
